import { useState } from 'react'

import { t, Trans } from '@lingui/macro'
import ShareVisibility from 'Root/App/Dialog/Share'
import Chip from 'Root/App/Item/Chip'
import ItemVisibility from 'Root/App/Item/ItemVisibility'
import Paragraph from 'Root/App/Paragraph'
import Title from 'Root/App/Title'
import { getItemVisibility } from 'lib/get-item-visibility'

interface UpdateSharePanelVisibilityProps {
  id: string
  element: any
  type: 'content' | 'collection'
  onConfirm: (visibility) => void
}

const getSharingMode = () => ({
  public: t`con il mondo`,
  private: t`privatamente`,
  protected: t`privatamente`,
  need_registration: t`con registrazione`,
})

const UpdateSharePanelVisibility = ({
  id,
  element,
  type,
  onConfirm,
}: UpdateSharePanelVisibilityProps) => {
  const [isDialogOpen, setDialogOpen] = useState(false)
  const sharingMode = getSharingMode()

  return (
    <span id="change-visibility">
      <Chip
        icon={
          <ItemVisibility
            id={element.id}
            iconClassName="text-gray-900"
            wrapperClassName="bg-gray-200 w-8 h-8 rounded-lg flex items-center justify-center"
            visibility={element.visibility}
          />
        }
        onClick={() => setDialogOpen((isDialogOpen) => !isDialogOpen)}
        highlight
        highlightCustomClass="p-3 flex items-center"
      >
        <span className="flex flex-col">
          <Title size="XS">
            <Trans>{`Condiviso ${
              sharingMode[
                getItemVisibility(element.visibility, element.need_registration)
              ]
            }`}</Trans>
          </Title>
          <Paragraph className="underline">
            <Trans>Modifica visibilità</Trans>
          </Paragraph>
        </span>
      </Chip>

      <ShareVisibility
        id={id}
        isOpen={isDialogOpen}
        onClose={() => setDialogOpen((isDialogOpen) => !isDialogOpen)}
        onConfirm={onConfirm}
        elementType={type}
        visibility={element.visibility}
        need_registration={element.need_registration}
      />
    </span>
  )
}

export default UpdateSharePanelVisibility
